// Counts down the cart reservation window. The end time lives in sessionStorage so
// cart partial re-renders and page loads continue the same countdown; it restarts at zero.
class SCartTimer extends HTMLElement {
  #interval = 0;

  connectedCallback() {
    const duration = Number(this.dataset.duration) || 300;
    const key = 'glosara-cart-timer-end';
    let end = Number(sessionStorage.getItem(key));
    if (!end || end < Date.now()) {
      end = Date.now() + duration * 1000;
      sessionStorage.setItem(key, String(end));
    }
    const output = this.querySelector('[data-timer-output]');
    const tick = () => {
      let remaining = Math.round((end - Date.now()) / 1000);
      if (remaining <= 0) {
        end = Date.now() + duration * 1000;
        sessionStorage.setItem(key, String(end));
        remaining = duration;
      }
      const minutes = String(Math.floor(remaining / 60)).padStart(2, '0');
      const seconds = String(remaining % 60).padStart(2, '0');
      if (output) output.textContent = `${minutes}:${seconds}`;
    };
    tick();
    this.#interval = setInterval(tick, 1000);
  }

  disconnectedCallback() {
    clearInterval(this.#interval);
  }
}

if (!customElements.get('s-cart-timer')) customElements.define('s-cart-timer', SCartTimer);
